import { getTelegramWebApp } from './telegramWebApp';

/** Confirm dialog that works in Telegram Mini App (window.confirm is unreliable there). */
export function confirmAction(message: string): Promise<boolean> {
  const showConfirm = getTelegramWebApp()?.showConfirm;
  if (showConfirm) {
    return new Promise((resolve) => {
      showConfirm(message, (confirmed) => resolve(Boolean(confirmed)));
    });
  }
  return Promise.resolve(window.confirm(message));
}
